import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinpunefocorporate() {



  const cardData =
  {
    keyword: 'Urbania On Rent in Pune for Corporate',
    heading: 'Amruta Travels: Urbania On Rent in Pune for Corporate',
    headingDescription: 'Amruta Travels Pvt. Ltd. provides Urbania on Rent in Pune for Corporate clients who value professionalism, comfort, and punctuality. Our premium Force Urbania vans are designed for business meetings, airport transfers, client visits, and corporate events, offering a luxurious and efficient travel experience. Each Urbania features executive-style reclining seats, powerful air conditioning, ambient interiors, and Wi-Fi-enabled options, ensuring productivity and relaxation on the go. With uniformed chauffeurs, timely pickups, and a fleet maintained to perfection, Amruta Travels’ Corporate Urbania Rental in Pune is the ideal choice for companies seeking dependable and high-class transportation. Experience world-class corporate mobility with elegance, privacy, and unmatched service quality.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
    {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
   {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



    "services": [
    {
      "name": "Urbania On Rent in Pune for Corporate",
      "description": "Urbania On Rent in Pune for Corporate offers tailored van rental solutions designed specifically for business needs. Whether it’s for daily office commutes, corporate meetings, or business tours, these vans provide comfortable, timely, and professional transport services across Pune."
    },
    {
      "name": "Corporate Urbania Hire Pune",
      "description": "Corporate Urbania Hire Pune specializes in renting vans to companies for staff transportation, business events, and corporate outings. With a focus on punctuality and comfort, these services help streamline employee travel with reliable vehicles and professional drivers."
    },
    {
      "name": "Corporate Urbania Van Pune",
      "description": "Corporate Urbania Van Pune provides spacious and well-maintained vans for transporting corporate groups. Suitable for shuttle services, airport transfers, and inter-office travel, these vans ensure efficient and comfortable journeys for employees."
    },
    {
      "name": "Office Travel Urbania Pune",
      "description": "Office Travel Urbania Pune offers van rentals customized for daily office commutes and employee transport. These vans provide a hassle-free, cost-effective solution to ensure smooth transit between home and workplace within Pune."
    },
    {
      "name": "Employee Shuttle Urbania Pune",
      "description": "Employee Shuttle Urbania Pune focuses on shuttle services designed to transport employees conveniently and safely. With flexible scheduling and comfortable vans, this service helps companies manage staff logistics efficiently."
    },
    {
      "name": "Urbania Hire in Hinjewadi",
      "description": "Urbania Hire in Hinjewadi caters specifically to the IT hub, offering reliable van rentals for corporate clients working in this area. These vans support office commutes, client visits, and business events with on-time service."
    },
    {
      "name": "Urbania Hire in Baner",
      "description": "Urbania Hire in Baner provides convenient access to vans for corporate and personal use. Known for its professional service and well-maintained vehicles, this service supports daily office travel and corporate outings in the Baner area."
    },
    {
      "name": "Urbania Hire in Hadapsar",
      "description": "Urbania Hire in Hadapsar offers corporate van rentals in one of Pune's key commercial zones. Perfect for staff transport, business tours, and event travel, these vans combine comfort with punctual service."
    },
    {
      "name": "Corporate Outing Urbania Pune",
      "description": "Corporate Outing Urbania Pune arranges luxury vans for company trips, team-building events, and outings. These vehicles provide spacious seating and premium amenities to ensure a memorable group travel experience."
    },
    {
      "name": "Corporate Meeting Van Pune",
      "description": "Corporate Meeting Van Pune provides specialized vans for transporting executives and teams to meetings and conferences. These vans prioritize comfort and privacy, helping professionals arrive fresh and prepared."
    },
    {
      "name": "Business Tour Urbania Pune",
      "description": "Business Tour Urbania Pune offers van rentals designed for extended business trips and client visits. With flexible packages and luxury features, these vans cater to the needs of traveling professionals."
    },
    {
      "name": "Urbania Hire for Company Events Pune",
      "description": "Urbania Hire for Company Events Pune provides vans for corporate seminars, workshops, and special events. These vehicles ensure timely and organized transport for employees and guests attending company functions."
    },
    {
      "name": "Corporate Transfer Urbania Pune",
      "description": "Corporate Transfer Urbania Pune specializes in airport and intercity transfers for corporate clients. These vans offer reliable and comfortable travel options for business travelers moving between locations."
    },
    {
      "name": "Affordable Corporate Urbania Pune",
      "description": "Affordable Corporate Urbania Pune offers budget-friendly van rental options for companies seeking reliable yet economical employee transport solutions without compromising on quality."
    },
    {
      "name": "AC Urbania for Office Pune",
      "description": "AC Urbania for Office Pune provides air-conditioned vans tailored for comfortable and climate-controlled office commutes, ensuring employees travel relaxed and refreshed."
    },
    {
      "name": "Non AC Urbania for Corporate Pune",
      "description": "Non AC Urbania for Corporate Pune offers cost-effective van rental services without air conditioning, suitable for short distance travels and budget-conscious companies."
    },
    {
      "name": "Luxury Corporate Van Pune",
      "description": "Luxury Corporate Van Pune features high-end vans with premium interiors and advanced amenities for executive travel, VIP client transport, and high-profile corporate events."
    },
    {
      "name": "Urbania Hire near Me Pune",
      "description": "Urbania Hire near Me Pune helps businesses and individuals find the closest available Urbania vans for quick and convenient rentals within Pune, supporting last-minute travel requirements."
    }
  ],
  "tableData": [
    ["Urbania On Rent in Pune for Corporate", "Corporate Urbania Hire Pune"],
    ["Corporate Urbania Van Pune", "Office Travel Urbania Pune"],
    ["Employee Shuttle Urbania Pune", "Urbania Hire in Hinjewadi"],
    ["Urbania Hire in Baner", "Urbania Hire in Hadapsar"],
    ["Corporate Outing Urbania Pune", "Corporate Meeting Van Pune"],
    ["Business Tour Urbania Pune", "Urbania Hire for Company Events Pune"],
    ["Corporate Transfer Urbania Pune", "Affordable Corporate Urbania Pune"],
    ["AC Urbania for Office Pune", "Non AC Urbania for Corporate Pune"],
    ["Luxury Corporate Van Pune", "Urbania Hire near Me Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Urbania On Rent in Pune for Corporate",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd provides efficient and comfortable Urbania rental services in Pune tailored for corporate travel and business events."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating",
    "WhyChoosedescription": "Our Urbania vans offer ample space and ergonomic seating, ensuring a productive and relaxing ride for corporate teams."
  },
  {
    "WhyChooseheading": "Regular Maintenance and Sanitization",
    "WhyChoosedescription": "Vehicles are regularly serviced and thoroughly cleaned to guarantee safety and hygiene for corporate passengers."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Enjoy upfront pricing with no hidden fees, providing cost-effective transportation solutions for your business needs."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental plans designed to fit your corporate schedule."
  },
  {
    "WhyChooseheading": "Professional and Punctual Drivers",
    "WhyChoosedescription": "Our experienced drivers ensure timely pickups and courteous service, allowing your team to focus on their work."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round-the-clock to assist with bookings, inquiries, and last-minute changes."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking Process",
    "WhyChoosedescription": "Book your Urbania rental easily online or via phone, with prompt vehicle delivery across Pune."
  }
]






















  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer Urbania on rent for corporate use in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides Urbania vehicles on rent for corporate purposes in Pune, ideal for business travel and events.',
  },
  {
    question: 'How can I rent an Urbania for corporate use in Pune with Amruta Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24×7 customer support team in Pune.',
  },
  {
    question: 'What amenities are available in the Urbania vehicles for corporate rentals in Pune?',
    answer: 'Our Urbania vehicles come with comfortable seating, air conditioning, and necessary safety features to ensure a productive and comfortable ride.',
  },
  {
    question: 'Are the drivers experienced and professional for corporate Urbania hires in Pune?',
    answer: 'Yes, our drivers are trained, courteous, and experienced in providing safe and timely corporate transportation services.',
  },
  {
    question: 'Can Urbania vehicles be hired for corporate meetings, events, airport transfers, and tours in Pune?',
    answer: 'Absolutely. Our Urbania vehicles are perfect for corporate meetings, events, airport transfers, and sightseeing tours in Pune.',
  },
  {
    question: 'Is the Urbania corporate rental service available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24×7 availability for Urbania corporate rentals to suit your business schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for Urbania corporate hires?',
    answer: 'All vehicles are sanitized thoroughly before each trip, and drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'What payment options are accepted for Urbania corporate rentals in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the Urbania corporate rental period in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you anytime during your Urbania rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Sharma',
    feedback: 'The Urbania from Amruta Travels Pune was perfect for our corporate event. The driver was professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Nair',
    feedback: 'Great service for corporate Urbania rental. Amruta Travels ensured a comfortable and smooth ride.',
    rating: 5,
  },
];








































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Pune for Corporate",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/23.jpg",
  "description": "Book Urbania On Rent in Pune for Corporate with Amruta Travels Pvt. Ltd. offering AC, Non-AC, and Luxury Force Urbania vans for employee transport, business trips, and corporate events. Reliable, comfortable, and affordable corporate Urbania rental in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "15180"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3900",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/urbania-on-rent-in-pune-for-corporate"
  }
};






  return (
    <div>
<Helmet>
  <title>Urbania On Rent in Pune for Corporate | Force Urbania Van Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book Urbania On Rent in Pune for Corporate with Amruta Travels Pvt. Ltd. offering AC, Non-AC, and Luxury Force Urbania vans for office staff travel, corporate trips, and business events. Affordable and reliable Urbania rental in Pune."
  />
  <meta
    name="keywords"
    content="Urbania On Rent in Pune for Corporate, Corporate Urbania Hire Pune, Corporate Urbania Van Pune, Office Travel Urbania Pune, Employee Shuttle Urbania Pune, Urbania Hire in Hinjewadi, Urbania Hire in Baner, Urbania Hire in Hadapsar, Corporate Outing Urbania Pune, Corporate Meeting Van Pune, Business Tour Urbania Pune, Urbania Hire for Company Events Pune, Corporate Transfer Urbania Pune, Affordable Corporate Urbania Pune, AC Urbania for Office Pune, Non AC Urbania for Corporate Pune, Luxury Corporate Van Pune, Urbania Hire near Me Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/23.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniaonrentinpunefocorporate;